import { render } from "./ViewTransfertPage.vue?vue&type=template&id=6a7a0c17&ts=true"
import script from "./ViewTransfertPage.vue?vue&type=script&lang=ts"
export * from "./ViewTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__